export type PdfStoredFile = {
  id: string;
  type: 'PdfStoredFile';
  url: string;
  name: string;
  pageCount: number;
  processingStatus: 'queued' | 'started' | 'finished' | 'errored';
};
